import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Persisted pixel width for the docked sidebar column.
export const CHAT_WIDGET_SIDEBAR_DEFAULT_WIDTH = 440;
export const CHAT_WIDGET_SIDEBAR_MIN_WIDTH = 400;
// The sidebar grows to a fraction of the viewport (scales with the screen),
// capped by an absolute ceiling for ultrawide displays.
export const CHAT_WIDGET_SIDEBAR_MAX_FRACTION = 0.6;
export const CHAT_WIDGET_SIDEBAR_MAX_WIDTH = 1200;

// Effective max for the current viewport, never below the min. SSR-safe.
export const getChatWidgetSidebarMaxWidth = (): number => {
  if (typeof window === 'undefined') return CHAT_WIDGET_SIDEBAR_MAX_WIDTH;
  const fraction = Math.round(window.innerWidth * CHAT_WIDGET_SIDEBAR_MAX_FRACTION);
  return Math.max(CHAT_WIDGET_SIDEBAR_MIN_WIDTH, Math.min(CHAT_WIDGET_SIDEBAR_MAX_WIDTH, fraction));
};
export const clampChatWidgetSidebarWidth = (n: number) => Math.min(getChatWidgetSidebarMaxWidth(), Math.max(CHAT_WIDGET_SIDEBAR_MIN_WIDTH, n));
type ChatWidgetSidebarWidthState = {
  width: number;
  setWidth: (next: number) => void;
};
const useStore = create<ChatWidgetSidebarWidthState>()(persist(set => ({
  width: CHAT_WIDGET_SIDEBAR_DEFAULT_WIDTH,
  // Clamp on write so a stored width can never exceed the (viewport-relative) bounds.
  setWidth: next => set({
    width: clampChatWidgetSidebarWidth(next)
  })
}), {
  name: 'percy.chat-widget-sidebar-width',
  merge: (persisted, current) => {
    const raw = (persisted as Partial<ChatWidgetSidebarWidthState>)?.width;
    const width = Number.isFinite(raw) ? clampChatWidgetSidebarWidth(raw as number) : CHAT_WIDGET_SIDEBAR_DEFAULT_WIDTH;
    return {
      ...current,
      width
    };
  }
}));
const useChatWidgetSidebarWidth = () => {
  return useStore();
};
export default useChatWidgetSidebarWidth;